import logoUrl from '../assets/logoPsiMammoliti.svg';
import { renderConstanciaPdf, type ConstanciaData } from './constanciaPdfTemplate';

/**
 * Rasteriza el logo SVG institucional a PNG — jsPDF no soporta SVG nativamente.
 * Vive acá (no en el template) porque depende del DOM/canvas del navegador;
 * el template en sí queda puro y portable entre portales.
 */
export async function loadLogoAsPngDataUrl(size = 160): Promise<string | null> {
  try {
    const img = new Image();
    const loaded = new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error('No se pudo cargar el logo'));
    });
    img.src = logoUrl;
    await loaded;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, size, size);
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}

/**
 * Genera y descarga la Constancia en PDF de un/a paciente.
 * Punto de entrada específico de portal (hoy solo psi-platform); el render en
 * sí (`renderConstanciaPdf`) es reutilizable y podrá invocarse desde el portal
 * de pacientes en una futura iteración.
 *
 * Nombre de archivo idéntico al de psima: `Constancia de Atención - {nombre}.pdf`,
 * con la misma sanitización (solo saca los caracteres inválidos en un nombre de
 * archivo — no reemplaza espacios ni acentos).
 */
export async function generateConstanciaPdf(data: ConstanciaData): Promise<void> {
  const logoDataUrl = await loadLogoAsPngDataUrl();
  const doc = renderConstanciaPdf(data, { logoDataUrl });
  const safeName = data.patientFullName.replace(/[\\/:*?"<>|]/g, '');
  doc.save(`Constancia de Atención - ${safeName}.pdf`);
}
